<div class="page-wrapper section-hr-direct">

    <app-multi-lingual></app-multi-lingual>
    <div class="new-login-container">
        <div class="tab-content">

            <div role="tabpanel" *ngIf="!success" class="tab-pane active" id="forgot-password">
                <div class="heading">{{'ForgotPassword.Text'| translate}}</div>

                <form [formGroup]="forgotPasswordForm" novalidate
                    (ngSubmit)="forgotPassword(forgotPasswordForm.value, forgotPasswordForm.valid)">

                    <p class="plain">{{'ForgotPassword.Message'|translate}}</p>
                    <span class="error-message"
                        *ngIf="forgotPasswordForm.controls['Email'].errors?.required && forgotPasswordForm.controls['Email'].touched">
                        {{'ForgotPassword.Email.Error.Required'| translate}}
                    </span>
                    <span class="error-message"
                        *ngIf="!forgotPasswordForm.controls['Email'].errors?.required && forgotPasswordForm.controls['Email'].errors?.email">
                        {{'ForgotPassword.Email.Error.Invalid' |translate}}
                    </span>

                    <input formControlName="Email" placeholder="{{'Common.Email'|translate}}" type="text">
                    <input type="submit" id="forgotPassword" [disabled]="!forgotPasswordForm.valid" class="btn btn-main"
                        value="{{'Common.Submit' | translate}}" />

                </form>
                <a class="loginlink" style="display: block;text-align: center;"
                    [routerLink]="['/login']">{{'ForgotPassword.Login'| translate}}</a>


            </div>

            <div role="tabpanel" *ngIf="success" style="display:block" class="tab-pane" id="forgot-password-success">
                <div class="heading">{{'ForgotPassword.Text'| translate}}</div>
                <p class="plain">{{successmsg}} </p>
                <div class="row">
                    <div class="col-xs-6">
                        <a href="javascript:void(0)" class="btn btn-main"
                            (click)="success=false">{{'ForgotPassword.BackButton'| translate}}</a>
                    </div>
                    <div class="col-xs-6">
                        <a [routerLink]="['/login']" class="btn btn-main">{{'ForgotPassword.BackLogin'| translate}}</a>

                    </div>
                </div>
            </div>


        </div>
    </div>
</div>
<app-outer-footer></app-outer-footer>